//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "EmptyScheduleCalendar",
  computed: {
    ...mapGetters({
      viewportWidth: 'viewport/width',
    })
  },
  watch: {
    viewportWidth() {
      this.$emit('change', this.$el.clientWidth)
    }
  },
  mounted() {
    this.$emit('change', this.$el.clientWidth)
  }
}
